import { Component, Inject } from '@angular/core';
import {
    MAT_SNACK_BAR_DATA,
    MatSnackBarRef,
} from '@angular/material/snack-bar';

export interface SnackbarData {
    message: string;
    type?: 'success' | 'error';
}

@Component({
    selector: 'app-snackbar',
    templateUrl: './snackbar.component.html',
    styleUrls: ['./snackbar.component.scss'],
})
export class SnackbarComponent {
    constructor(
        @Inject(MAT_SNACK_BAR_DATA) public data: SnackbarData,
        private _ref: MatSnackBarRef<SnackbarComponent>
    ) {}

    get icon(): string {
        return this.data.type === 'error' ? 'error' : 'check_circle';
    }

    dismiss(): void {
        this._ref.dismiss();
    }
}
